<template>
    <div class="py-2 md:py-12 relative pl-14">
        <div
            class="flex flex-col md:flex-row md:justify-left items-center mb-5"
        >
            <div>
                <h1 class="text-slate-800 text-2xl font-semibold leading-loose">
                    10xTravel+
                </h1>
                <p class="text-md text-slate-500 text-center pt-1">
                    Exclusive members-only deals, expert support, discounts,
                    surprises, and more.
                </p>
            </div>
        </div>
        <div>
            <h2
                class="text-slate-800 text-lg font-medium leading-7 px-0 pt-8 pb-6"
            >
                Meet your 10xTravel+
            </h2>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <!-- Tarjeta 1 -->
                <div
                    class="relative flex flex-col px-3 py-4 bg-white shadow-md rounded-xl h-[160px]"
                >
                    <div class="flex flex-col flex-grow">
                        <h3 class="font-medium text-lg text-slate-900 mb-2">
                            Benefits and details
                        </h3>
                        <p
                            class="text-md text-slate-500 leading-relaxed line-clamp-2"
                        >
                            Find key details about your exclusive membership.
                        </p>
                        <p class="font-medium text-md text-slate-900 mt-auto">
                            View
                        </p>
                    </div>
                    <div class="absolute bottom-0 right-0 w-24 h-16">
                        <icon
                            icon="benefits"
                            class="w-full h-full text-orange-500"
                        />
                    </div>
                </div>

                <!-- Tarjeta 2 -->
                <div
                    class="relative flex flex-col px-3 py-4 bg-white shadow-md rounded-xl h-[160px]"
                >
                    <div class="flex flex-col flex-grow">
                        <h3 class="font-medium text-lg text-slate-900 mb-2">
                            Program updates
                        </h3>
                        <p
                            class="text-md text-slate-500 leading-relaxed line-clamp-2"
                        >
                            Check the latest updates to the program.
                        </p>
                        <p class="font-medium text-md text-slate-900 mt-auto">
                            View
                        </p>
                    </div>
                    <div class="absolute bottom-0 right-0 w-24 h-16">
                        <icon
                            icon="stars"
                            class="w-full h-full text-orange-500"
                        />
                    </div>
                </div>

                <!-- Tarjeta 3 -->
                <div
                    class="relative flex flex-col px-3 py-4 bg-white shadow-md rounded-xl h-[160px]"
                >
                    <div class="flex flex-col flex-grow">
                        <h3 class="font-medium text-lg text-slate-900 mb-2">
                            Free travel course
                        </h3>
                        <p
                            class="text-md text-slate-500 leading-relaxed line-clamp-2"
                        >
                            Learn to travel the world for free with our free
                            course.
                        </p>
                        <p class="font-medium text-md text-slate-900 mt-auto">
                            View
                        </p>
                    </div>
                    <div class="absolute bottom-0 right-0 w-24 h-16">
                        <icon
                            icon="travel-course"
                            class="w-full h-full text-orange-500"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="flex py-16 pb-6 justify-between items-start self-stretch">
            <h2 class="text-slate-800 text-lg font-medium leading-7">
                My membership
            </h2>
            <div class="flex items-center">
                <span
                    class="flex items-center gap-1.5 text-slate-800 text-sm font-medium font-['Inter'] leading-tight"
                >
                    <icon icon="settings" />
                    Manage subscription
                </span>
            </div>
        </div>
        <div class="flex flex-col items-start gap-6 self-stretch">
            <div
                class="flex p-6 flex-col items-start self-stretch rounded-lg bg-white shadow-md"
            >
                <div class="flex pb-8 flex-col items-start gap-1 self-stretch">
                    <div class="flex items-center gap-2">
                        <icon icon="pass" />
                        <h3
                            class="text-slate-800 text-lg font-medium font-['Inter'] leading-7"
                        >
                            Award booking
                        </h3>
                    </div>
                    <p class="text-md text-slate-500">
                        Let our experts book the best flights for you with your
                        points and miles.
                    </p>
                </div>
                <div class="flex w-160 items-start gap-16">
                    <!-- First Column -->
                    <div class="flex flex-col gap-4">
                        <h3 class="font-medium text-md text-slate-900">
                            Free award bookings
                        </h3>
                        <div class="flex items-center gap-2">
                            <span class="text-2xl font-bold text-slate-800">
                                0
                            </span>
                            <span>/1 per year</span>
                        </div>
                        <div
                            class="h-1 self-stretch rounded-full bg-slate-400"
                        ></div>
                        <p class="text-md text-slate-500">
                            Round trip for 2 people, issued as a credit of $275
                            <br />
                            towards your bookings.
                        </p>
                    </div>
                    <!-- Second Column -->
                    <div class="flex flex-col gap-4">
                        <h3 class="font-medium text-md text-slate-900">
                            Personal discount paid award bookings
                        </h3>
                        <div class="flex items-center gap-2">
                            <span class="text-2xl font-bold text-slate-800">
                                15%
                            </span>
                            <span>without limit</span>
                        </div>
                    </div>
                </div>
                <div class="flex pt-6 flex-col items-start">
                    <button class="btn btn-orange !ml-0">
                        Start your booking
                    </button>
                </div>
                <AwardBookingCardItem />
            </div>

            <ConsultationsCardItem />

            <div
                class="flex p-6 flex-col items-start self-stretch rounded-lg bg-white shadow-md"
            >
                <div class="flex pb-8 flex-col items-start gap-1 self-stretch">
                    <div class="flex items-center gap-2">
                        <icon icon="microphone" />
                        <h3 class="font-medium text-lg text-slate-900">
                            Podcast voicemail
                        </h3>
                    </div>
                    <p class="text-md text-slate-500">
                        Get your questions and comments answered in upcoming
                        episodes.
                    </p>
                </div>
                <div class="flex pt-2 flex-col items-start">
                    <button
                        @click="showModal = true"
                        class="btn btn-orange !ml-0"
                    >
                        Send voicemail
                    </button>
                    <VoicemailModal
                        v-if="showModal"
                        :show="showModal"
                        @close="showModal = false"
                    />
                </div>
                <div class="flex pt-12 pb-1 flex-col items-start">
                    <h2 class="font-medium text-md text-slate-900">
                        Latest episodes
                    </h2>
                </div>
                <podcast-latest-episodes />
            </div>
        </div>
        <div class="mt-20">
            <h2 class="font-medium text-lg text-slate-900 text-left pb-8">
                Settings
            </h2>
            <div
                class="flex p-6 flex-col items-start self-stretch rounded-lg bg-white shadow-md"
            >
                <div class="flex pb-8 flex-col items-start gap-1 self-stretch">
                    <div class="flex items-center gap-2">
                        <icon icon="headphones" />
                        <h3 class="font-medium text-lg text-slate-900">
                            Subscription
                        </h3>
                    </div>
                    <p class="text-md text-slate-500">
                        Manage your membership subscription.
                    </p>
                </div>
                <div class="flex flex-col items-start gap-1">
                    <div class="flex items-center gap-1">
                        <h2 class="font-medium text-lg text-slate-900">
                            10xTravel+ membership
                        </h2>
                        <div
                            class="flex px-2 py-1 items-center gap-1 rounded-full bg-[var(--Semantics-Success-Surface-Light,#ECFDF5)]"
                        >
                            <icon icon="CheckIcon" class="w-4 h-4" />
                            <span class="text-sm text-green-700">Active</span>
                        </div>
                    </div>
                    <div class="flex items-center gap-1 text-sm text-slate-500">
                        <span>Renewal date Sep 15, 2025</span>
                        <span>&#8226;</span>
                        <span>Annual payment, $199</span>
                    </div>
                </div>
                <div class="flex pt-6 flex-col items-start">
                    <button
                        class="flex px-4 py-2.5 justify-center items-start gap-2 rounded-md border border-slate-200 bg-white shadow-sm text-black text-sm"
                    >
                        Manage subscription
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useTravelPlusStore } from '@/store/travelplus';
import AwardBookingCardItem from './award-booking-card-item.vue';
import Icon from '@/components/ui/icon/icon.vue';
import PodcastLatestEpisodes from './podcast-latest-episodes.vue';
import VoicemailModal from '@/components/travel-plus/Modal/VoicemailModal.vue';
import ConsultationsCardItem from './consultations-card-item.vue';

const travelPlusStore = useTravelPlusStore();
const showModal = ref(false);
</script>

<style scoped lang="scss">
.bg-benefits {
    //background-image: url('@/assets/icons/benefits.svg');
    background-size: 96px 64px;
    background-position: right bottom;
    background-repeat: no-repeat;
}

.bg-stars {
    //background-image: url('@/assets/icons/stars.svg');
    background-size: 96px 64px;
    background-position: right bottom;
    background-repeat: no-repeat;
}

.bg-travel-course {
    //background-image: url('@/assets/icons/travel-course.svg');
    background-size: 96px 64px;
    background-position: right bottom;
    background-repeat: no-repeat;
}
</style>
